import { AuthSession } from 'types';

export const getAuthHeaders = (authSession: AuthSession): { [key: string]: string } => ({
  Authorization: authSession.getAccessToken().getJwtToken(),
});
